export const iconFontAwesomeBuildingsCampground = (
	<i className="fa-solid fa-campground"></i>
);
